import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, LocalService, Utils } from 'lib-base';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ConceptosImpuestosService } from '../../../../services/database/conceptos-impuestos.service';
import { ITipoTramiteCosto } from '../../../../shared/interfaces/database/liquidacion';

@Component({
  selector: 'app-tipo-tramite-costo',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TableModule, TooltipModule,
    ConfirmPopupModule, DialogModule, ButtonModule, CalendarModule, InputNumberModule, CustomTableComponent
  ],
  providers: [ConfirmationService],
  template: `
    <custom-table [config]="customTable">
    </custom-table>
  `
})
export class TipoTramiteCostoComponent implements OnInit {

  @Input() tipoTramiteId!: number;

  translations: any = {};
  tipoTramiteCosto: ITipoTramiteCosto[] = [];
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _t: TranslateService, public readonly ls: LocalService,
    private readonly _cs: ConfirmationService, private readonly _ms: MessageService, private readonly _lps: LoadingPanelService, private readonly _fb: FormBuilder,
    private readonly _cips: ConceptosImpuestosService
  ) {
  }

  ngOnInit(): void {
    this.translate();
    this.findByTipoTramiteId();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      noRegistros: this._t.get('form.msg.no-registros'),
      costo: this._t.get('common.costo'),
      fechaInicial: this._t.get('common.fechaInicial'),
      fechaFinal: this._t.get('common.fechaFinal'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      eliminarRegistro: this._t.get('msg.eliminarRegistro'),
      registroEliminado: this._t.get('msg.registroEliminado'),
      registroCreado: this._t.get('msg.registroCreado'),
      registroActualizado: this._t.get('msg.registroActualizado'),
      exito: this._t.get('common.exito'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      impuestoConcepto: this._t.get('common.impuestoConcepto'),
      nuevo: this._t.get('common.nuevo'),
      editar: this._t.get('common.editar'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      seleccionar: this._t.get('common.seleccionar')
    }));

    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'fechaInicial',
          header: this.translations.fechaInicial,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaFinal',
          header: this.translations.fechaFinal,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.DATE
        },
        {
          field: 'costo',
          header: this.translations.costo,
          sort: false,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.MONEY
        }               
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  //#region API Calls
  private findByTipoTramiteId() {
    this._cips.getConceptoImpuestoCostos(this.tipoTramiteId).subscribe({
      next: (data: ITipoTramiteCosto[]) => {
        this.tipoTramiteCosto = data.map(item => ({
          ...item,
          fechaInicial: new Date(item.fechaInicial)
        }));
        this.customTableComponent.data = this.tipoTramiteCosto;
      }
    });
  }
  //#endregion
}
